import React from "react";
import Plot from 'react-plotly.js';

export default function CyberResilienceChart() {
  return (
    <div className="p-4 space-y-6" style={{ backgroundColor: '#c6d7dd', minHeight: '100vh' }}>
      <h2 className="text-2xl font-bold">
        Organizations reporting insufficient cyber resilience
      </h2>
      <p>
        Smaller organizations are struggling to ensure cyber resilience, while
        larger organizations show steady progress
      </p>

      <Plot
        data={[
          {
            x: ['2022', '2025'],
            y: [5, 35],
            type: 'scatter',
            mode: 'lines+markers+text',
            name: 'Small',
            line: { color: '#00CED1', width: 4 },
            marker: { size: 10 },
            text: ["5%", "35%"],
            textposition: "top center"
          },
          {
            x: ['2022', '2025'],
            y: [13, 7],
            type: 'scatter',
            mode: 'lines+markers+text',
            name: 'Large',
            line: { color: '#00BFFF', width: 4 },
            marker: { size: 10 },
            text: ["13%", "7%"],
            textposition: "top center"
          }
        ]}
        layout={{
          autosize: true,
          height: 400,
          margin: { t: 50, l: 60, r: 30, b: 50 },
          yaxis: {
            title: {
              text: "My organization's cyber resilience is insufficient"
            },
            range: [0, 40],
            ticksuffix: "%"
          },
          xaxis: {
            title: 'Year'
          },
          legend: {
            orientation: "h",
            x: 0.1,
            y: -0.3
          },
          paper_bgcolor: '#c6d7dd',
          plot_bgcolor: '#c6d7dd'
        }}
        style={{ width: "100%" }}
        useResizeHandler={true}
      />

      <div className="w-full max-w-md mx-auto text-center">
        <Plot
          data={[{
            type: 'indicator',
            mode: 'gauge+number',
            value: 71,
            gauge: {
              axis: { range: [0, 100] },
              bar: { color: "#00CED1" },
              bgcolor: "white",
              borderwidth: 2,
              bordercolor: "#00CED1",
              steps: [
                { range: [0, 50], color: "#E0FFFF" },
                { range: [50, 100], color: "#AFEEEE" }
              ]
            },
            number: {
              suffix: "%",
              font: { size: 48, color: "#008B8B" }
            },
            title: {
              text: "Critical tipping point",
              font: { size: 18, color: "#008B8B" }
            }
          }]}
          layout={{
            width: 320,
            height: 250,
            margin: { t: 0, b: 0, l: 0, r: 0 },
            paper_bgcolor: '#c6d7dd',
            plot_bgcolor: '#c6d7dd'
          }}
        />
        <p className="text-gray-700">
          71% of cyber leaders at the Annual Meeting on Cybersecurity 2024 believe that
          small organizations have already reached a tipping point — they can no longer
          adequately secure themselves against complex cyber risks.
        </p>
      </div>
    </div>
  );
}
